import Cal, { getCalApi } from "@calcom/embed-react";
import { useEffect } from "react";
import { Box, Container, Typography } from '@mui/material';



export const HomeScheduleCall = () => {
    useEffect(() => {
        (async function () {
            const cal = await getCalApi({ namespace: "30min" });
            cal("ui", {
                hideEventTypeDetails: false,
                layout: "month_view"
            });
        })();
    }, []);

    return (
        <Box
            sx={{
                py: 15,
                // backgroundColor: 'background.paper',
                // width: '100%',
                // position: 'relative'
            }}
        >
            <Container maxWidth="lg">
                <Typography
                    variant="h2"
                    sx={{
                        fontWeight: 700,
                        textAlign: 'center',
                        mb: 8,
                        fontSize: { xs: '2rem', md: '2.5rem' }
                    }}
                >
                    Schedule a call
                </Typography>

                <Box
                    sx={{
                        // height: '700px',
                        // width: '100%',
                        borderRadius: 2,
                        overflow: 'hidden',
                        // boxShadow: (theme) => theme.shadows[4],
                    }}
                >
                    <Cal
                        namespace="30min"
                        calLink="support-team-qsszsx/30min"
                        style={{
                            width: "100%",
                            height: "100%",
                            overflow: "scroll"
                        }}
                        config={{
                            layout: "month_view",
                            hideEventTypeDetails: "0"
                        }}
                    />
                </Box>
            </Container>
        </Box>
    );
};

export default HomeScheduleCall;
